export const questions1 = [
  {
    questionText: 'Aus welchem Land kommt GOBI Cashmere?',
    answerId: true,
    answerOptions: [
      { key: 0, answerText: 'Deutschland', isCorrect: false, color: 'redColorBorder' },
      { key: 1, answerText: 'Mongolei', isCorrect: true, color: 'greenColorBorder' },
    ],
  },
  {
    questionText: 'Wie heisst die neueste Kollektion von GOBI Cashmere?',
    answerId: true,
    answerOptions: [
      { key: 0, answerText: 'Organic', isCorrect: false, color: 'redColorBorder' },
      { key: 1, answerText: 'Mineral', isCorrect: true, color: 'greenColorBorder' },
    ],
  },
  {
    questionText: 'Treibt GOBI Cashmere nur Online-Shop?',
    answerId: true,
    answerOptions: [
      { key: 0, answerText: 'Nein', isCorrect: true, color: 'greenColorBorder' },
      { key: 1, answerText: 'Ja', isCorrect: false, color: 'redColorBorder' },
    ],
  },
];

export const questions2 = [
  {
    questionText: 'Wann wurde das Unternehmen Gobi in der Mongolei gegründet?',
    answerOptions: [
      { answerText: '1981', isCorrect: true },
      { answerText: '1986', isCorrect: false },
    ],
  },
  {
    questionText: 'Hat GOBI Cashmere physische Geschäfte im Ausland?',
    answerOptions: [
      { answerText: 'Ja', isCorrect: true },
      { answerText: 'Nein', isCorrect: false },
    ],
  },
  {
    questionText: 'Wie heisst unsere Vision?',
    answerOptions: [
      { answerText: 'Top Qualität zum fairen Preis.', isCorrect: false },
      { answerText: 'Wir machen Kaschmir zum Lifestyle.', isCorrect: true },
    ],
  },
];
export const questions3 = [
  {
    questionText: 'Wo befindet sich die GOBI Cashmere Filiale in Deutschland?',
    answerOptions: [
      { key: 0, answerText: 'Hamburg', isCorrect: false, color: 'redColorBorder' },
      { key: 1, answerText: 'Berlin', isCorrect: true, color: 'greenColorBorder' },
    ],
  },
  {
    questionText: 'Wie heisst unsere Mission?',
    answerOptions: [
      { key: 0, answerText: 'Eine große Auswahl an Designs', isCorrect: false, color: 'redColorBorder' },
      { key: 1, answerText: 'Teilen von Genuss & Freude', isCorrect: true, color: 'greenColorBorder' },
    ],
  },
  {
    questionText: 'In welcher Stadt befindet sich der Hauptsitz von GOBI Cashmere?',
    answerOptions: [
      { key: 0, answerText: 'Ulaanbaatar', isCorrect: true, color: 'greenColorBorder' },
      { key: 1, answerText: 'Mongolei', isCorrect: false, color: 'redColorBorder' },
    ],
  },
];

export const hatData = [
  { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-81.jpg?v=1600163137&quot' },
  { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087--02.jpg?v=1600163134' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-1331.jpg?v=1600163140' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-147.jpg?v=1600163143' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-520.jpg?v=1600163147' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-760.jpg?v=1600163150' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-1479.jpg?v=1600163153' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-1236.jpg?v=1600163156' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-254.jpg?v=1600163159' },
  // { imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-57.jpg?v=1600163162' },
];
